export default __webpack_public_path__ + "static/media/login.d37f8dd9.svg";